module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_8023.35da78d3.png";